export default {
  title: 'Olas',
  actions: {
    create: 'Crear una ola',
    delete: 'Borrar esta ola'
  },
  step: {
    create: 'Crear un paso',
    edited: 'Editar un paso'
  },
  deletion: {
    message: '¿Estás seguro de que quieres suprimir esta ola?'
  },
  empty: {
    title: 'No hay olas',
    message: 'Para crear una ola, nada más sencillo, basta con hacer clic en el siguiente enlace:'
  },
  list: {
    name: 'nombre',
    status: 'estado',
    who: 'que',
    where: 'o',
    when: 'cuando',
    reward: 'recompensa'
  }
}



// WEBPACK FOOTER //
// ./src/translations/es/waves.js